var map = {
	"./bodyText.vue": 6931,
	"./headlineBig.vue": 6806,
	"./headlineMedium.vue": 4601,
	"./headlineSmall.vue": 8710,
	"./imageSegment.vue": 716,
	"./subheadline.vue": 5272,
	"./videoSegment.vue": 6011
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8763;